import Photo from '../components/Photo';
import { FYC_ART } from '../config';
import { blocksOf, prettifyTitle } from '../lib/parse';

/**
 * Finds what the FYC page opens with, from the FYC sheet:
 *  - the heading and the two subtitles under it (the "For Your Grammy Consideration" chapter)
 *  - the band photo (first Image row that isn't the old banner graphic)
 *  - the album cover (first Images row, or any picture with "cover" in its name)
 */
export function fycHeroData(chapters) {
  const headChapter = chapters.find((c) => /grammy|consideration/i.test(c.title || ''));
  const images = chapters.slice(0, 3).flatMap((c) => blocksOf(c, 'image'));
  const groups = chapters.flatMap((c) => blocksOf(c, 'images'));

  const photo = (images.find((i) => i.platform !== 'desktop' && !/fyc|banner/i.test(i.src)) || {}).src || FYC_ART.photo;
  const coverGroup = groups.find((g) => g.srcs.some((s) => /cover/i.test(s))) || groups.find((g) => g.platform === 'mobile');
  const cover = coverGroup ? (coverGroup.srcs.find((s) => /cover/i.test(s)) || coverGroup.srcs[0]) : FYC_ART.cover;

  const banner = images.filter((i) => i.platform === 'desktop' && /fyc|banner/i.test(i.src)).map((i) => i.src);
  const lines = headChapter ? blocksOf(headChapter, 'subtitle').map((b) => prettifyTitle(b.text)) : [];
  return {
    title: headChapter ? prettifyTitle(headChapter.title) : 'For Your Grammy® Consideration',
    lines,
    photo,
    cover,
    // chapters that the hero replaces, and pictures not to repeat further down
    skip: new Set([headChapter, chapters[0] && !chapters[0].title ? chapters[0] : null].filter(Boolean)),
    hide: new Set([photo, cover, ...banner]),
  };
}

export default function FycHero({ data }) {
  const [category, album] = data.lines;
  return (
    <section className="fyc-hero" aria-labelledby="fyc-title">
      <div className="fyc-tiles" aria-hidden="true" />
      <div className="wrap fyc-inner">
        <h1 id="fyc-title" className="display fyc-title">{data.title}</h1>
        {category && <p className="fyc-category">{category}</p>}
        {album && <p className="display display--m fyc-album">{album}</p>}
        <div className="fyc-art">
          <figure className="fyc-cover tile-frame">
            <Photo src={data.cover} alt="Global Prayer album cover" eager fallback />
          </figure>
          <figure className="fyc-photo tile-frame">
            <Photo src={data.photo} alt="Ize Trio: Chase Morrin, Naseem Alatrash and George Lernis" position="50% 0%" eager fallback />
          </figure>
        </div>
      </div>
    </section>
  );
}
